import React from 'react';
import clsx from 'clsx';
import BrandHeader from './BrandHeader';
import LocalNavigationHeader from './localNavigation/LocalNavigationHeader';
import style from './Header.module.scss';
import ServiceLogo from '../ServiceLogo';
import ServiceMenu from './ServiceMenu';
import EnvironmentIndicator from '../EnvironmentIndicator';
import { AperzaUserProvider } from './AperzaUserContext';
import { useAperzaUser } from './UseAperzaUser';
import { AccountHeader } from './AccountHeader';
import { HeaderSearch } from './HeaderSearch';
import { MobileMenuButton } from './menulist/MobileMenuButton';
import { ResponsiveProvider } from '../util/ResponsiveContext';
import { useResponsive } from '../util/UseResponsive';
export function Header({ type, fixed, user, unreadMessageCount, children }) {
    // * Static NOTIFICATIONs
    const notifications = [
    // { title: '利用規約改定のお知らせ', dateString: '2022/11/25', url: 'https://aperza.com' },
    // {
    //   title: 'メンテナンスによるサービス停止のご案内',
    //   dateString: '2022/11/25',
    //   url: 'https://aperza.com',
    // },
    // { title: '冬季休業期間のご案内', dateString: '2022/11/25', url: 'https://aperza.com' },
    ];
    const methods = useAperzaUser({ user, serviceType: type, notifications, unreadMessageCount });
    const responsiveMethods = useResponsive();
    return (React.createElement(ResponsiveProvider, { ...responsiveMethods },
        React.createElement(AperzaUserProvider, { ...methods },
            React.createElement("header", { className: clsx(style.header, { [style.fixedHeader]: fixed }) },
                React.createElement(EnvironmentIndicator, null),
                React.createElement(BrandHeader, { fixed: fixed }),
                responsiveMethods.isDesktop && (React.createElement("div", { className: style.mainHeader },
                    React.createElement(ServiceLogo, null),
                    React.createElement(ServiceMenu, null),
                    React.createElement(HeaderSearch, null),
                    React.createElement(AccountHeader, null))),
                responsiveMethods.isMobile && (React.createElement("div", { className: style.mobileMainHeader },
                    React.createElement("div", { className: style.mobileServiceRow },
                        React.createElement("div", { className: style.mobileServiceLogoWrapper },
                            React.createElement(ServiceLogo, null)),
                        React.createElement(MobileMenuButton, null)),
                    React.createElement(HeaderSearch, null))),
                React.createElement(LocalNavigationHeader, { fixed: fixed }),
                children && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: style.childWrapper }, children))),
                React.createElement("div", { className: style.headerBorder })))));
}
